define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    window.lpTag = window.lpTag || {};
    lpTag.lpSmileyEmojisController = function (model) {

        var Translator = require("i18n/translator"),
            smileyEmojisController = {applicationType: "lpSmileyEmojisController"},
            smilliesConfig = lpUtils.cloneObject(require("web-agent-widgets/Config/smileysAndEmojiesConfig.json")),
            smileyObj = {};

        smileyEmojisController.replaceImagesByEmojiCodes = function(container) {
            var imgArr = $('img[data-emojicode]', container);
            for(var i=0;i<imgArr.length;i++) {
                container.innerHTML = container.innerHTML.replace(imgArr[i].outerHTML, imgArr[i].getAttribute('data-emojicode'));
            }
        };

        smileyEmojisController.replaceEmojiCodesByImages = function(context, emojiMode, data) {
            var template = require("web-agent-templates/LP_emoji_image.html"),
            // var template = lpUtils.loadResource("web-agent-templates/LP_emoji_image.html"),
                emojiImg,
                imgTemp;

            var smileyDetailsArr = ((emojiMode) ? smilliesConfig.emoji : smilliesConfig.smiley).detailsArray;
            for(var i=0;i<smileyDetailsArr.length;i++) {
                imgTemp = {src: smileyDetailsArr[i].src, emojicode: smileyDetailsArr[i].emojicode, description: smileyDetailsArr[i].description};
                emojiImg = context.templateString(template, imgTemp, false);
                data = data.replace(new RegExp(smileyDetailsArr[i].emojicode, 'g'), emojiImg);
            }

            return data;
        };

        smileyEmojisController.replaceEmojiCodesByAlternate = function(data) {
            var smileyDetailsArr = smilliesConfig.emoji.detailsArray;
            for(var i=0;i<smileyDetailsArr.length;i++) {
                data = data.replace(new RegExp(smileyDetailsArr[i].emojicode, 'g'), ':' + smileyDetailsArr[i].alternate + ':');
            }

            return data;
        };


        smileyEmojisController.removeEmojisFromText = function(text) {
            var smileyDetailsArr = smilliesConfig.emoji.detailsArray;
            for(var i=0;i<smileyDetailsArr.length;i++) {
                text = text.replace(new RegExp(smileyDetailsArr[i].emojicode, 'g'), ' ');
            }
            return text;
        };

        smileyEmojisController.getConfig = function(smileyMode) {
            if(!smileyObj.hasOwnProperty(smileyMode)) {
                init(smileyMode);
            }
            return smileyObj[smileyMode];
        };

        function init(smileyMode) {
            smileyObj[smileyMode] = smilliesConfig[smileyMode];

            var smileyDetailsArr = smileyObj[smileyMode].detailsArray;
            for(var i=0;i<smileyDetailsArr.length;i++) {
                if(!smileyDetailsArr[i].base_64) {
                    smileyDetailsArr[i].description = Translator.translate(smileyDetailsArr[i].description);
                    smileyDetailsArr[i].src = getCdnDomain(lpUtils.removeProtocolFromURL(agentLEManager.getLEUrlResolverGetUrl(smileyDetailsArr[i].src)));
                }else if(smileyMode === 'emoji'){
                    smileyDetailsArr[i].alternate = Translator.translate(smileyDetailsArr[i].alternate);
                }
            }
        }

        function getCdnDomain(cdnDomain) {
            if (cdnDomain && cdnDomain.indexOf('http') === -1) {
                return 'https://' + cdnDomain;
            }
        }

        return smileyEmojisController;
    };

    return lpTag.lpSmileyEmojisController;

});
